export enum DataTableColumnTypeEnum {
  media = 'media',
  tag = 'tag',
  scale = 'scale',
  button = 'button'
}
